import { render } from "./RegistrationContactFieldComponent.vue?vue&type=template&id=4328c8a2&scoped=true"
import script from "./RegistrationContactFieldComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationContactFieldComponent.vue?vue&type=script&lang=js"

import "./RegistrationContactFieldComponent.vue?vue&type=style&index=0&id=4328c8a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4328c8a2"]])

export default __exports__